import React from "react";
import { X } from "lucide-react";

export function Panel({ title, onClose, children, wide }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-6 bg-black/70 backdrop-blur-sm" onClick={onClose} data-testid="panel-backdrop">
      <div
        className={`card relative w-full ${wide ? "max-w-4xl" : "max-w-lg"} max-h-[90vh] flex flex-col pop-in`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 sm:p-5 border-b border-slate-800">
          <h2 className="font-head font-black text-2xl sm:text-3xl uppercase tracking-tight text-white">{title}</h2>
          <button onClick={onClose} className="btn-ghost p-2 rounded-lg" data-testid="panel-close-btn"><X size={20} /></button>
        </div>
        <div className="p-4 sm:p-5 overflow-y-auto scroll-thin">{children}</div>
      </div>
    </div>
  );
}
